import { useNavigate } from "react-router-dom";
import { SignOut } from "@phosphor-icons/react";
import { Logo } from "@/components/Logo";
import { ThemeToggle } from "@/components/ThemeToggle";
import { useAuth } from "@/context/AuthContext";

export const AppHeader = () => {
  const { user, logout } = useAuth();
  const navigate = useNavigate();
  return (
    <header className="no-print sticky top-0 z-40 bg-background/70 backdrop-blur-xl border-b border-border">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 h-16 flex items-center justify-between">
        <button onClick={() => navigate("/dashboard")} data-testid="header-home-btn">
          <Logo />
        </button>
        <div className="flex items-center gap-4">
          {user?.is_admin && (
            <button onClick={() => navigate("/admin")} data-testid="header-admin-btn"
              className="text-sm font-medium text-muted-foreground hover:text-brand transition-colors">
              Admin
            </button>
          )}
          {user && (
            <div className="flex items-center gap-2.5">
              {user.picture && <img src={user.picture} alt="" className="h-7 w-7 rounded-full" />}
              <span className="text-sm font-medium hidden sm:block">{user.name}</span>
            </div>
          )}
          <button onClick={logout} data-testid="logout-btn"
            className="flex items-center gap-1.5 text-sm text-muted-foreground hover:text-foreground transition-colors">
            <SignOut size={18} /> Çıkış
          </button>
          <ThemeToggle />
        </div>
      </div>
    </header>
  );
};
